import React, { useCallback } from 'react'
import { Link } from 'react-router-dom'
import styles from './TrackCaptionItem.module.css'

type Props = {
  content?: React.ReactNode
  id?: number | null | undefined
  url: string | null | undefined
  onClick?: (id: number) => void // TODO: use native `url` over `onClick` for linking
}

const TrackCaptionItem = ({ content, id, url, onClick }: Props) => {
  const handleClick = useCallback(
    (event: React.SyntheticEvent<any>) => {
      if (id && onClick) {
        event.stopPropagation()
        onClick(id)
      }
    },
    [id, onClick],
  )
  if (!content) return null

  if (id && onClick) {
    return (
      <span
        className={styles.trackCaptionItemClickable}
        onClick={handleClick}
        translate="no"
      >
        {content}
      </span>
    )
  } else if (url) {
    return (
      <Link to={url}>
        <span className={styles.trackCaptionItemClickable} translate="no">
          {content}
        </span>
      </Link>
    )
  } else {
    return <span translate="no">{content}</span>
  }
}

export default React.memo<Props>(TrackCaptionItem)
